<div class="create-pass-container">
	<h2 class="row-center title content-title">
		<h1 i18n="@@registerUser-createPasswordTitle">Create Password</h1>
	</h2>

	<div class="column flex-start">
		<div>
			<mat-form-field
				appearance="outline"
				class="input-full-width margin-right-8 margin-bottom-16px"
				subscriptSizing="dynamic"
			>
				<mat-label i18n="@@registerUser-createPasswordPasswordInput">Password</mat-label>
				<input
					matInput
					[formControl]="passwordFormControl"
					[type]="hide ? 'password' : 'text'"
					data-automation-id="password-input"
				/>
				<mat-icon matSuffix (click)="hide = !hide" data-automation-id="create-pwd-password-button">{{
					hide ? 'visibility_off' : 'visibility'
				}}</mat-icon>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-full-width margin-bottom-16px" subscriptSizing="dynamic">
				<mat-label i18n="@@registerUser-createPasswordConfirmPasswordInput">Confirm Password</mat-label>
				<input
					matInput
					[formControl]="confirmPasswordFormControl"
					[type]="hide ? 'password' : 'text'"
					data-automation-id="confirm-password-input"
				/>
				<mat-icon matSuffix (click)="hide = !hide" data-automation-id="create-pwd-confirm-password-button">{{
					hide ? 'visibility_off' : 'visibility'
				}}</mat-icon>
			</mat-form-field>
		</div>

		<app-password-validation
			#passwordValidation
			[passwordFormControl]="passwordFormControl"
			[confirmPasswordFormControl]="confirmPasswordFormControl"
		>
		</app-password-validation>
	</div>

	<div class="button-spacing">
		<button
			mat-button
			class="secondary-button"
			i18n="@@registerUser-createPasswordBack"
			data-automation-id="create-pwd-back-button"
			(click)="onBackClicked()"
		>
			Back
		</button>

		<button
			mat-button
			class="primary-button"
			i18n="@@registerUser-createPasswordNext"
			[disabled]="!passwordValidation.passwordIsValid()"
			data-automation-id="create-pwd-next-button"
			(click)="confirm()"
		>
			Next
		</button>
	</div>
</div>
